import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from 'styled-components'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Disclaimer from '@/components/Disclaimer'
import Credits from '@/components/Credits'
import { dasherize } from '@/utilities'
import VotacionTitle from '@/components/VotacionTitle'

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

const unique = (arr, attr) => {
  // console.log('arr', arr, 'attr', attr)
  return [...new Set(arr.map(item => item[attr]))]
}

const StComuna = styled.span`
  &:last-of-type {
    .sep {
      display: none;
    }
  }
`

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allGoogleSheetInfoDistritosRow {
        nodes {
          circunscripcionelectoral
          comuna
          distrito
          id
          nombreenpadron
          region
          votantes
        }
      }
      allGoogleSheetCandidatosConvencionConstituyenteRow(
        filter: { candidaturaconfirmadaalultimoboletin: { ne: "No" } }
      ) {
        nodes {
          id
          nombre
          distrito
          region
          edad
          lista
          escanoreservadosino
          pueblooriginariosicorresponde
          sexo
          militanciamilitantedepartidooindependiente
          partidopoliticosicorresponde
          correoelectronico
          perteneceaunpueblooriginario
          profesionuoficio
          colegiodeegreso
          telefono
          twitter
          instagram
          facebook
        }
      }
    }
  `)

  const distritos = groupBy(
    data.allGoogleSheetCandidatosConvencionConstituyenteRow.nodes,
    'distrito',
  )

  const distritoInfo = groupBy(
    data.allGoogleSheetInfoDistritosRow.nodes,
    'distrito',
  )

  // console.log('distritoInfo', distritoInfo)

  return (
    <Layout>
      <SEO />
      <div className="pt-16 content">
        <div className="p-3 mx-auto md:max-w-screen-sm sm:p-8">
          <h1 className="mb-4 leading-none text-center">Todos los distritos</h1>
          <div>
            {Object.keys(distritos).map((distrito, i) => {
              if (distrito === '999') {
                return (
                  <VotacionTitle
                    key={i}
                    to={`/pueblos-originarios/`}
                    as="link"
                    className="mb-4 text-xl">
                    <span className="mb-4 text-4xl font-bold ">
                      Pueblos Originarios
                    </span>
                  </VotacionTitle>
                )
              }
              return (
                <VotacionTitle
                  key={i}
                  to={`/distrito-${dasherize(distrito)}/`}
                  as="link"
                  className="mb-4 text-xl">
                  <span className="block mb-4 text-4xl font-bold">
                    Distrito {distrito}
                  </span>
                  {distritoInfo[distrito] && (
                    <>
                      {unique(distritoInfo[distrito], 'comuna').map(
                        (comuna, i) => {
                          return (
                            <StComuna
                              key={i}
                              className="text-xl tracking-normal">
                              {comuna}
                              <i className="inline-block w-2 h-2 mb-1 ml-2 mr-2 bg-black rounded-full sep"></i>
                            </StComuna>
                          )
                        },
                      )}
                    </>
                  )}
                </VotacionTitle>
              )
            })}
          </div>
        </div>
      </div>
      <Disclaimer />
      <Credits />
    </Layout>
  )
}
export default IndexPage
